import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { FullSizeCenteredColumn } from '../FlexBox';
import Dialog from '../Dialog';

const DeviceDialog = function DeviceDialog({
  open,
  defaultDevice,
  onClose,
  onSubmit,
  devices = [],
  notFound = false,
}) {
  const intl = useIntl();
  const [value, setValue] = useState(defaultDevice);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleClose = () => {
    onClose('');
    setValue('');
  };
  const handleSubmit = () => {
    onSubmit(value);
  };

  useEffect(() => {
    if (devices && defaultDevice) {
      setValue(defaultDevice);
    }
  }, [devices, defaultDevice]);

  return (
    <Dialog
      id="device-dialog"
      title="SELECT_A_DEVICE"
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      width="sm"
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      dividers
    >
      <FullSizeCenteredColumn padding="16px" gap="16px">
        {notFound && (
          <Typography color="error" variant="body2">
            {intl.messages.DEVICE_NOT_FOUND_SELECT_NEW}
          </Typography>
        )}
        <FormControl fullWidth>
          <InputLabel id="device-select-inputlabel">
            {intl.messages.DEVICE}
          </InputLabel>
          <Select
            id="device-select"
            label={intl.messages.DEVICE}
            value={value}
            onChange={handleChange}
          >
            {devices.length > 0 ? (
              devices.map(({ device_id, user_agent }) => (
                <MenuItem key={device_id} value={device_id}>
                  {user_agent}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>{intl.messages.NO_DEVICES_AVAILABLE}</MenuItem>
            )}
          </Select>
        </FormControl>
      </FullSizeCenteredColumn>
    </Dialog>
  );
};

export default DeviceDialog;
